import React from "react";
import Typography from "../../common/Typography/Typography";
import Button from "../../common/Buttons/Button/Button";
import styles from "./ActionPreviewItem.module.css";
import Icon from "../../common/Icon/Icon";
import { Action } from "../../../types/Action";

enum HighlightColor {
    red = "before:bg-plum-500",
    amber = "before:bg-mustard-500",
    green = "before:bg-mint-300",
}

interface Props {
    action: Pick<Action, "ID" | "Rating" | "Findings" | "DateDifference" | "SiteName">;
    className?: string;
    onClick?: (actionId: Action["ID"]) => void;
}

const ActionPreviewItem = ({ action, className, onClick }: Props) => {
    const handleClick = onClick ? () => onClick(action.ID) : undefined;

    return (
        // The button below has pointer events disabled but can still be used by keyboard users.
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
            className={`${styles.actionPreviewItem} ${handleClick ? "cursor-pointer" : ""} ${HighlightColor[action.Rating]} ${className}`}
            onClick={handleClick}
        >
            <div className={styles.actionPreviewInner}>
                <Typography as="p" variant="paragraph" className="line-clamp-2">
                    {action.Findings}
                </Typography>
                <div className={styles.actionSite}>
                    <span>{action.SiteName}</span>
                    <span className={styles.actionDateDot} />
                    <span>{action.DateDifference}</span>
                </div>
            </div>
            <Button className="pointer-events-none" size="none" type="button" variant="none" onClick={handleClick}>
                <Icon icon="chevron_right" />
            </Button>
        </div>
    );
};

export default ActionPreviewItem;
